import $ from 'jquery';
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

export default class ContentCarousel {
    constructor() {
        if ($('.js-content-carousel').length) {
            const contentCarousel = new Swiper('.js-content-carousel', {
                autoHeight: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination"
                },
                slidesPerView: 1,
                watchOverflow: true
            });
        };
    };
};
